import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthDrive, setIsAuthDrive] = useState(
    localStorage.getItem("espaceChauffeur") === "true"
  );
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    if (isAuthDrive) {
      const storedPerms = localStorage.getItem("chauffeurPerms");
      if (storedPerms) {
        setPermissions(JSON.parse(storedPerms));
      }
    }
  }, [isAuthDrive]);

  const login = (userData) => {
    if (userData && userData.infoUser && userData.infoUser.length > 0) {
      const userInfo = userData.infoUser[0];
      
      setUser(userInfo.idUser);
      setIsAuthDrive(true);
      setPermissions(userInfo.perm);
      
      localStorage.setItem("espaceChauffeur", "true");
      localStorage.setItem("chauffeurPerms", JSON.stringify(userInfo.perm));
      localStorage.setItem("idChauffeur", userData.idChauffeur);
      localStorage.setItem("nomChauffeur", userData.nomPrenom);

      const expirationTime = 300 * 60 * 1000;
      
      setTimeout(() => {
        logout();
      }, expirationTime);

      return true; 
    }
    return false; 
  };

  const logout = () => {
    setUser(null);
    setIsAuthDrive(false);
    setPermissions([]);
    
    localStorage.removeItem("espaceChauffeur");
    localStorage.removeItem("chauffeurPerms");
    localStorage.removeItem("idChauffeur");
    localStorage.removeItem("nomChauffeur");
    // localStorage.removeItem("us");
    // localStorage.removeItem("pr");
  };

  return (
    <AuthContext.Provider
      value={{ user, isAuthDrive, permissions, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthChauffeur = () => {
  return useContext(AuthContext);
};